const OutgrowLoader = () => {
  return (
    <div className="pre-loader outgrow-loader">
      <img
        src="https://dlvkyia8i4zmz.cloudfront.net/BfcoBqtbS7K8Koyso1TS_logo_animation.gif"
        height={140}
        width={140}
      />
    </div>
  );
};

export default OutgrowLoader;
